import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { NotificationsService } from '@services/notifications.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, SideMenuComponent],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent {
  @Input() logoUrl = '/assets/icons/new-logo-header.svg';
  @Input() searchPlaceholder = 'Buscar';
  @Input() initialQuery = '';
  @Output() search = new EventEmitter<string>();
  @Output() openMenu = new EventEmitter<void>();

  query = this.initialQuery;
  menuOpen = false;
  isSideMenuOpen = false;
  userName = 'Usuario'; // Puedes reemplazarlo por el nombre real si lo tienes

  private auth = inject(AuthService);
  private router = inject(Router);
  // Exponer el servicio para usar en la plantilla con async pipe
  public notificationsService = inject(NotificationsService);

  // Verificar si el usuario está autenticado
  get isAuthenticated(): boolean {
    return this.auth.isAuthenticated();
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/'], { replaceUrl: true });
  }

  doSearch() {
    this.search.emit((this.query || '').trim());
  }

  toggleMenu() {
    this.isSideMenuOpen = !this.isSideMenuOpen;
  }

  closeSideMenu() {
    this.isSideMenuOpen = false;
  }
}
